import React, { useRef, useLayoutEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./Quote.module.css";
import bg from "../../images/לילך מורד גן יבנה 94.webp";

gsap.registerPlugin(ScrollTrigger);

const Quote = () => {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  const sentence =
    "הבית שלכם הוא ההשקעה הכי גדולה שתעשו בחיים, ואני כאן כדי לוודא שהוא באמת ישרת אתכם";
  const words = sentence.split(" ");

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const fills = textRef.current.querySelectorAll(`.${styles.wordFill}`);

      gsap.set(fills, { opacity: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top top",
          end: "+=150%",
          scrub: 1,
          pin: true,
          fastScrollEnd: true,
        },
      });

      fills.forEach((word) => {
        tl.to(
          word,
          {
            opacity: 1,
            duration: 0.4,
            ease: "none",
          },
          "+=0.1"
        );
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={containerRef} className={styles.section}>
      <img className={styles.bg} src={bg} alt="" loading="lazy" />
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h2 ref={textRef} className={styles.text}>
          {words.map((word, i) => (
            <span key={i} className={styles.word}>
              <span className={styles.wordBase}>{word}</span>
              <span className={styles.wordFill}>{word}</span>
            </span>
          ))}
        </h2>
      </div>
    </section>
  );
};

export default Quote;
